export const CM_PER_INCH = 2.54;
export const M_PER_CM = 0.01;
export const KG_PER_POUND = 0.45359237;